export enum DocumentMode {
  SUBMISSIONS = 'submissions',
  TEMPLATES = 'templates',
  ENDORSEMENTS = 'endorsements',
  BRANDING = 'branding',
  OTHER = 'other',
}

export type DocumentOperation = 'edit' | 'status-change';
